import { Tooltip } from "react-bootstrap";

const useTooltips = () => {
    const tooltips = {
        taskActive: (
            <Tooltip id="button-tooltip" className="tolltipssss">
                The task is active on the website and accepting submissions. The due date has not yet passed.
            </Tooltip>
        ),
        editTask: (
            <Tooltip id="button-tooltip" className="tolltipssss text-justify">
                You can edit a task as long as no participants have joined. Once someone joins, editing will be locked to keep things fair and avoid changing the requirements. Please note that the Reward Amount, Currency, Task Title, and Task Description cannot be edited at any stage.
            </Tooltip>
        ),

        reviewSubmissions: (
            <Tooltip id="button-tooltip" className="tolltipssss">
                The task creator has 24 hours to review the submissions and select a winner.
            </Tooltip>
        ),
        reviewSubmissionsCreator: (
            <Tooltip id="button-tooltip" className="tolltipssss">
                You have 24 hours to review the submissions and select a winner.
            </Tooltip>
        ),
        reviewSubmissionsParticipated: (
            <Tooltip id="button-tooltip" className="tolltipssss">
                The task creator has 24 hours to review the submissions and select a winner.
            </Tooltip>
        ),
        reviewSubmissionsWinner: (
            <Tooltip id="button-tooltip" className="tolltipssss">
                The task creator has 24 hours to review the submissions and select a winner.
            </Tooltip>
        ),

        winnerSelected: (
            <Tooltip id="button-tooltip" className="tolltipssss">
                Participants who submitted their work and were not selected as the winner by the task creator have 24 hours to open a dispute.
            </Tooltip>
        ),
        winnerSelectedCreator: (
            <Tooltip id="button-tooltip" className="tolltipssss">
                Participants who submitted their work and were not selected as the winner have 24 hours to open a dispute.
            </Tooltip>
        ),
        winnerSelectedWinner: (
            <Tooltip id="button-tooltip" className="tolltipssss">
                You have been selected as the winner by the task creator. Other participants who submitted their work have 24 hours to open a dispute.
                {/* test winnnerrr */}
            </Tooltip>
        ),
        winnerSelectedParticipated: (
            <Tooltip id="button-tooltip" className="tolltipssss">
                You were not selected as the winner by the task creator. You have 24 hours to open a dispute.
            </Tooltip>
        ),


        disputeOpen: (
            <Tooltip id="button-tooltip" className="tolltipssss">
                A dispute has been opened and is being reviewed by DOP Oracles. After 48 hours, the voting period will end, and the winner will be determined.
            </Tooltip>
        ),
        taskCompleted: (
            <Tooltip id="button-tooltip" className="tolltipssss">
                The winner has successfully claimed the reward, and the task is now completed.
            </Tooltip>
        ),
        winnerSelectedShort: (
            <Tooltip id="button-tooltip" className="tolltipssss">
                The winner has been determined.
            </Tooltip>
        ),
    };

    const getTooltip = (key) => tooltips[key] || null;

    return {
        getTooltip,
    };
};

export default useTooltips;
